import Barcode from './barcode';

export default Barcode;
